export default function deleteChangesPopup(module){
    this.popupHide();
    this.removeStorage(`changes-${module}-${this.dataGet('conf/user/id')}`);
};
